package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RequestOtpRequest(
    val email: String
)

@Serializable
data class VerifyOtpRequest(
    val email: String,
    @SerialName("otp_code")
    val otpCode: String
)
